<template>
  <div>
    <cancel-heading>Are you completely sure?  Read below!</cancel-heading>
    <cancel-content>Before you hit that cancel button, please make sure you're okay with losing:</cancel-content>

    <cancel-box label="If you cancel:">
      <cancel-feature-list/>
    </cancel-box>

    <cancel-content>If you've decided to stay with us, please let us know exactly what you need to be more successful.  You have our commitment to do everything in our power to help you get there!  Your success is how we measure our success.</cancel-content>
  </div>
</template>

<script>
import CancelContent from "./components/CancelContent.vue";
import CancelFeatureList from "./components/CancelFeatureList.vue";
import CancelHeading from "./components/CancelHeading.vue";
import CancelBox from "./components/CancelBox.vue";

export default {
  name: "LastChance",
  components: {CancelBox, CancelHeading, CancelFeatureList, CancelContent}
}
</script>
